export enum SectionNameEnum {
  allAboutPrizm = 'Все о Prizm',
  howToWork = 'Как работать с Prizm',
  forZIIoT = 'Prizm для ZIIoT',
  guidelines = 'Гайдлайны',
  components = 'Компоненты',
  charts = 'Графики',
  tools = 'Инструменты',
}

export enum SectionNameEnglishEnum {
  allAboutPrizm = 'All About Prizm',
  howToWork = 'How to Work with Prizm',
  forZIIoT = 'Prizm for ZIIoT',
  guidelines = 'Guidelines',
  components = 'Components',
  charts = 'Charts',
  tools = 'Tools',
}
